import { render } from "./SaleItemCard.vue?vue&type=template&id=1d6b9b71&scoped=true"
import script from "./SaleItemCard.vue?vue&type=script&lang=js"
export * from "./SaleItemCard.vue?vue&type=script&lang=js"

import "./SaleItemCard.vue?vue&type=style&index=0&id=1d6b9b71&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6b9b71"]])

export default __exports__